import { ResultWrapper } from './ResultWrapper';

export interface Ok {
  success: true;
  hasValue: false;
}

export interface OkVal<TValue> {
  success: true;
  hasValue: true;
  value: TValue;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type OkResult<T = any> = Ok | OkVal<T>;

/**
 * Returns an empty successful result.
 */
function ok(value?: undefined): Ok;

/**
 * Returns a successful result with a typed string or number value.
 * @param value A typed string or number.
 */
function ok<T extends string | number>(value: T): OkVal<T>;

/**
 * Returns a successful result with a typed value.
 * @param value The value to return.
 */
function ok<T>(value: T): OkVal<T>;

function ok<T>(value?: T): Ok | OkVal<T> {
  if (value !== undefined) {
    return new ResultWrapper({
      success: true as const,
      value,
    }) as OkVal<T>;
  } else {
    return new ResultWrapper({
      success: true as const,
    }) as Ok;
  }
}

/**
 * An "Ok" result represents an operation that has been successfully completed.
 * The result may include a value.
 */
export const Ok = ok;
